module.exports = __webpack_public_path__ + "static/media/planet-outline.76e08aa9.svg";